export default class NavBurger {
    constructor(elem, config) {
        this.burger = elem;
        this.burger.addEventListener("click", this.toggleActive.bind(this));
        this.TIP = config;
    }

    toggleActive() {
        this.burger.classList.toggle("active");
        this.TIP.DOM.body.classList.toggle("o-h");
        this.TIP.DOM.header.classList.toggle("active");
    }

    reset() {
        this.burger.classList.remove("active");
        this.TIP.DOM.body.classList.remove("o-h");
        this.TIP.DOM.header.classList.remove("active");
    }
}
